import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
    name: 'search',
    initialState: {
        text: ""
    },
    reducers: {
        setSearchText: (state, action) => {
            state.text = action.payload ?? "";
        },
       
        clearSearchText: (state) => {
            state.text = "";
        }
    }
});

export const { setSearchText,clearSearchText } = searchSlice.actions;
export default searchSlice.reducer;